var exports = {
  "Z": "xcc377c0b--b738fe--faq-icon",
  "Y": "xcc377c0b--b738fe--tooltip",
};

module.exports = exports;
